import { createApiService } from './createApiService'

export const creatorsAPI = createApiService({
    reducerPath: 'creatorsAPI',
    tagTypes: ['Creator'],
    endpoints: (build: any) => ({
        getAllCreators: build.mutation({
            query: () => ({
                url: `/creators`,
                method: 'GET',
            }),
        }),
    }),
})

export const { useGetAllCreatorsMutation } = creatorsAPI